<div
  class="progress-label-base"
  [class]="{
    'progress-label-current': state() === LabelState.current,
    'progress-label-future': state() === LabelState.future,
    'progress-label-complete': state() === LabelState.complete,
    'progress-label-disabled': state() === LabelState.disabled,
    'progress-label-default': size() === LabelSize.default,
    'progress-label-small': size() === LabelSize.small,
  }">
  @if (state() === LabelState.complete) {
    <mat-icon class="progress-label-icon" svgIcon="check-circle" />
  } @else if (stepNumber()) {
    <div class="progress-label-number">
      {{ stepNumber() }}
    </div>
  }
  <div class="progress-label-title">
    {{ titleText() }}
  </div>
</div>
